export const equals = (s1, s2) => s1 && s2 && s1.id === s2.id;

export const uppercaseFirst = (s) =>
  s.length ? `${s.charAt(0).toUpperCase()}${s.slice(1).toLowerCase()}` : '';
